module.exports = __webpack_public_path__ + "img/product10.b96a1e4f.png";